import { render, staticRenderFns } from "./InvoicesTableSender.vue?vue&type=template&id=6e4be254&"
import script from "./InvoicesTableSender.vue?vue&type=script&lang=js&"
export * from "./InvoicesTableSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports